import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=c4f890e2&scoped=true"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=c4f890e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f890e2",
  null
  
)

export default component.exports